import { Send } from "lucide-react";
import { NodeCategory, registerNode } from "../../lib/register-node";
import { BrevoActionNodeEditor } from "./editor";
import { BrevoActionNodePanel } from "./panel";

const newNodeDefaultConfig: { eventName: string } = {
  eventName: "",
};

const newNodeDefaultValue: any = {
  actionType: "send_brevo_event",
  config: newNodeDefaultConfig,
};

export default registerNode<any["data"]>({
  type: "action:send_brevo_event",
  name: "workflowsEditor.nodes.sendBrevoEvent.title",
  description: "workflowsEditor.nodes.sendBrevoEvent.description",
  Icon: Send,
  category: NodeCategory.ACTION,
  color: "green",
  editor: {
    component: BrevoActionNodeEditor,
  },
  configPanel: {
    component: BrevoActionNodePanel,
  },
  newNodeDefaultData: newNodeDefaultValue,
});

export { BrevoActionNodeEditor } from "./editor";
export { BrevoActionNodePanel } from "./panel";
